/* eslint-disable @typescript-eslint/no-explicit-any */
import type * as React from 'react';

export function mergeRefs<T = any>(
    refs: Array<React.RefObject<T> | React.LegacyRef<T> | undefined | null>,
): React.RefCallback<T> {
    return (value) => {
        refs.forEach((ref) => {
            if (typeof ref === 'function') {
                ref(value);
            } else if (ref != null) {
                (ref as React.RefObject<T | null>).current = value;
            }
        });
    };
}
